// Motivo que pide el diálogo de guardar; se copia a cada ítem del lote.

export const SAVE_REASON_MIN_LENGTH = 10;

/** ¿El motivo tiene al menos el mínimo de caracteres, sin contar espacios en las orillas? */
export function isValidSaveReason(reason: string): boolean {
    return reason.trim().length >= SAVE_REASON_MIN_LENGTH;
}
